import { API_ENDPOINTS, API_KEY, API_HEADER_NAME } from '../constants/apiConstants';

// Helper function to create headers with API key
const createHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  // Add API key header if configured
  if (API_KEY && API_HEADER_NAME) {
    headers[API_HEADER_NAME] = API_KEY;
  }
  
  return headers;
};

export const commentService = {
  async getComments(params) {
    const queryParams = new URLSearchParams({
      retailAssoc: params.retailAssoc,
      coa: params.coa,
      period: params.period,
    });
    
    // Add username if provided
    if (params.username) {
      queryParams.append('username', params.username);
    }
    
    const response = await fetch(`${API_ENDPOINTS.COMMENTS}?${queryParams}`, {
      method: 'GET',
      headers: createHeaders(),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      
      // Handle authentication errors
      if (response.status === 401) {
        throw new Error('Authentication failed. Invalid or missing API key.');
      }
      
      throw new Error(errorData.message || 'Failed to fetch comments');
    }
    
    return response.json();
  },

  /**
   * Get all comments for a specific Period and Retail Association (across all COA values)
   * @param {Object} params - { period, retailAssoc }
   * @returns {Promise<Array>} - Array of comments
   */
  async getAllCommentsByPeriodAndRA(params) {
    const queryParams = new URLSearchParams({
      retailAssoc: params.retailAssoc,
      period: params.period,
    });
    
    const response = await fetch(`${API_ENDPOINTS.ALL_COMMENTS}?${queryParams}`, {
      method: 'GET',
      headers: createHeaders(),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      
      // Handle authentication errors
      if (response.status === 401) {
        throw new Error('Authentication failed. Invalid or missing API key.');
      }
      
      throw new Error(errorData.message || 'Failed to fetch all comments');
    }
    
    return response.json();
  },

  async createComment(commentData) {
    const response = await fetch(API_ENDPOINTS.COMMENTS, {
      method: 'POST',
      headers: createHeaders(),
      body: JSON.stringify(commentData),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      
      // Handle authentication errors
      if (response.status === 401) {
        throw new Error('Authentication failed. Invalid or missing API key.');
      }
      
      throw new Error(errorData.message || 'Failed to save comment');
    }
    
    return response.json();
  },

  async getCommentCount(params) {
    const queryParams = new URLSearchParams({
      retailAssoc: params.retailAssoc,
      coa: params.coa,
      period: params.period,
    });
    
    const response = await fetch(`${API_ENDPOINTS.COMMENTS_COUNT}?${queryParams}`, {
      method: 'GET',
      headers: createHeaders(),
    });
    
    if (!response.ok) {
      // Handle authentication errors
      if (response.status === 401) {
        throw new Error('Authentication failed. Invalid or missing API key.');
      }
      
      throw new Error('Failed to get comment count');
    }
    
    return response.json();
  },
};
